import i18next from "i18next"
import { EZeroValueSelectionOptionDisplayMode } from "../../Enum/EZeroValueSelectionOptionDisplayMode"

export interface ISelectionOptionPriceDisplay {
  label: string | null
  isFreeStyle: boolean
}

export const ResolveSelectionOptionPriceLabel = (
  value: number,
  basePrice: number,
  displayMode: EZeroValueSelectionOptionDisplayMode,
  quantity: number = 1,
): ISelectionOptionPriceDisplay => {
  const safeQuantity = Math.max(1, quantity)

  if (value > 0) {
    return { label: `+ R$ ${(value * safeQuantity).toFixed(2)}`, isFreeStyle: false }
  }

  switch (displayMode) {
    case EZeroValueSelectionOptionDisplayMode.ShowNothing:
      return { label: null, isFreeStyle: true }

    case EZeroValueSelectionOptionDisplayMode.ShowBasePrice:
      return { label: `R$ ${((basePrice + value) * safeQuantity).toFixed(2)}`, isFreeStyle: true }

    case EZeroValueSelectionOptionDisplayMode.ShowFree:
    default:
      return { label: i18next.t("publicMenu:add_product.free_option"), isFreeStyle: true }
  }
}
